<template>
  <v-card-text>
    <v-row>
      <v-col cols="12" md="8">
        <v-text-field v-model="name" label="Name of block (for administrative purposes; optional)"></v-text-field>
        <v-text-field
          v-model="youtubeId"
          label="YouTube Video ID"
          hint="You can paste the link of the YouTube video and we will extract the ID it"></v-text-field>
        <!-- <v-switch
          v-model="autoStart"
          :label="autoStart ? 'Start video automatically' : 'Do not start automatically (User must start video)'"
          hint="Not yet implemented"
          persistent-hint
          disabled></v-switch> -->
        <v-switch
          v-model="mustComplete"
          :label="mustComplete ? 'Video is required (they must complete the video before moving to the next slide)' : 'Video is optional (they can move to the next slide before completing)'"
          :hint="mustComplete ? 'Will hide the video controls so they cannot scroll through the video the first time through' : 'Student will have controls to fast-forward or rewind the video'"
          @change="(val) => { if(val) hideControls = true }"
          persistent-hint></v-switch>
        <v-switch
          v-model="hideControls"
          :label="hideControls ? 'Video controls will be hidden from the student the first time they watch the video' : 'Video controls will be visible every time the student watches the video'"
          :disabled="mustComplete"></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <youtube
          :video-id="youtubeId"
          player-width="160"
          player-height="90"></youtube>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  setup (props, { emit }) {
    const name = ref(props.value.name)
    const youtubeId = ref(props.value.youtubeId)
    const autoStart = ref('autoStart' in props.value ? props.value.autoStart : false)
    const mustComplete = ref('mustComplete' in props.value ? props.value.mustComplete : true)
    const hideControls = ref(false)

    watch(name, () => name.value !== props.value.name ? emit('update', { name: name.value }) : '')
    watch(autoStart, () => autoStart.value !== props.value.autoStart ? emit('update', { autoStart: autoStart.value }) : '')
    watch(mustComplete, () => mustComplete.value !== props.value.mustComplete ? emit('update', { mustComplete: mustComplete.value }) : '')
    watch(youtubeId, () => {
      if (youtubeId.value !== props.value.youtubeId) {
        if (youtubeId.value.substr(0, 8) === 'https://') {
          emit('update', { youtubeId: getIdFromURL(youtubeId.value) })
        } else {
          emit('update', { youtubeId: youtubeId.value.replaceAll(' ', '') })
        }
      }
    })
    watch(hideControls, () => hideControls.value !== props.value.hideControls ? emit('update', { hideControls: hideControls.value }) : '')

    watch(() => props.value, () => {
      if (props.value.name !== name.value) name.value = props.value.name
      if (props.value.youtubeId !== youtubeId.value) youtubeId.value = props.value.youtubeId
      if (props.value.autoStart !== autoStart.value) autoStart.value = props.value.autoStart
      if (props.value.mustComplete !== mustComplete.value) mustComplete.value = props.value.mustComplete
      if (props.value.hideControls !== hideControls.value) hideControls.value = props.value.hideControls
    })

    function validate () {
      if (youtubeId.value === '' || youtubeId.value == null) {
        alert('You must link to a YouTube video.')
        return false
      }
      return true
    }

    return {
      name,
      youtubeId,
      autoStart,
      mustComplete,
      hideControls,
      getIdFromURL,
      validate
    }
  }
}
</script>
